import { render } from "./HouseInteriorsView.vue?vue&type=template&id=4fafb150&scoped=true&ts=true&lang=pug"
import script from "./HouseInteriorsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseInteriorsView.vue?vue&type=script&lang=ts&setup=true"

import "./HouseInteriorsView.vue?vue&type=style&index=0&id=4fafb150&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fafb150"]])

export default __exports__